module.exports = __webpack_public_path__ + "media/images/views/job_share/step-3-b8a3169259298b85033eae1494f4c77c.png";